// extracted by mini-css-extract-plugin
export default {"coverLink":"AL-z","contentBox":"BL-z","zapposPromoContainer":"CL-z","zapposPromoGroupContainer":"DL-z","promos":"EL-z","bottom":"FL-z","top":"GL-z","right":"HL-z","left":"IL-z"};